// MyPage hub hydration (Tailwind rebuild, look site cũ). Chờ
// ink:api:ready → build DOM bằng Tailwind utility. Giá = yen thuần (toLocaleString).
// Escape text động. Fail-open.

(function () {
  'use strict';

  function boot() {
    const root = document.querySelector('[data-ink-mypage]');
    if (!root) return;

    const cfg = window.INK_MYPAGE || {};
    const orderUrl = cfg.orderUrl || '/pages/order';
    const addressUrl = cfg.addressUrl || '/pages/address';
    const printersUrl = cfg.printersUrl || '/pages/printers';
    const SI = cfg.statusImg || {};
    const NO_IMAGE = cfg.noImage || '';
    const STOCKOUT_IMG = cfg.stockoutImg || '';
    const SOLDOUT_IMG = cfg.soldoutImg || '';
    const fmt = (n) => Number(n || 0).toLocaleString('ja-JP');
    const pad = (n) => String(n).padStart(2, '0');
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const ymd = (ts) => { const d = new Date(ts * 1000); return `${d.getFullYear()}年${pad(d.getMonth() + 1)}月${pad(d.getDate())}日`; };


    // ?line=ok|ng — kết quả LINE ID連携. Callback Laravel đưa khách về đây
    // (port account.index.php:67-70 đọc $_SESSION['line_renkei_flg'] rồi in
    // message). Xoá param khỏi URL để refresh không hiện lại toast.
    (function showLineResult() {
      const params = new URLSearchParams(window.location.search);
      const result = params.get('line');
      if (result !== 'ok' && result !== 'ng') return;
      window.inkToast?.(
        result === 'ok'
          ? 'LINE ID連携が完了しました。'
          : 'LINE ID連携ができませんでした。お手数ですが最初からやり直してください。',
        result === 'ok' ? 'success' : 'error',
      );
      params.delete('line');
      const qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    })();

    // ?remindCart=close — link 配信停止 trong mail nhắc giỏ (port account.index.php
    // :57-62 → ps_user::closeRemindCart). Fail-soft: lỗi thì im lặng, phần còn lại
    // của マイページ vẫn render.
    const remindBox = root.querySelector('[data-remind-cart-message]');
    if (remindBox && new URLSearchParams(window.location.search).get('remindCart') === 'close') {
      (async () => {
        let done = false;
        try {
          const r = await window.inkApi.post('/mypage/remind-cart/close', {});
          const msg = r && r.data && r.data.message;
          // `inkApi` KHÔNG throw trên lỗi HTTP (401/429/5xx) — nó trả body kèm
          // `error`. Im lặng ở đây là khách không biết gì mà cờ cũng không đổi;
          // Joomla luôn hiện 1 trong 3 message, kể cả nhánh lỗi
          // (`PHPSHOP_CNET_REMINDCART_CLOSE_ERROR`).
          if (!msg) {
            remindBox.textContent = 'リマインドメールの配信停止が失敗した。';
            remindBox.className = 'mt-4 rounded border px-4 py-3 text-sm whitespace-pre-line border-ink-red bg-red-50';
            remindBox.hidden = false;
            remindBox.focus();
            return;
          }
          done = true;
          // 3 trạng thái, đổi CẢ nền lẫn viền: `already_closed` là thông tin chứ không
          // phải lỗi nên không nhuộm đỏ.
          const tone = {
            success: 'border-ink-green bg-[#f4fbf4]',
            already_closed: 'border-ink-grayLine bg-gray-50',
          }[r.data.status] || 'border-ink-red bg-red-50';
          remindBox.textContent = msg;
          remindBox.className = 'mt-4 rounded border px-4 py-3 text-sm whitespace-pre-line ' + tone;
          remindBox.hidden = false;
          remindBox.focus();
        } catch (e) {
          console.warn('remind cart close fail', e);
        } finally {
          // Chỉ dọn param khi server ĐÃ xử lý (không thì reload/Back là POST lại,
          // lần 2 luôn ra `already_closed`). Lỗi tạm thời thì GIỮ param để khách
          // reload là thử lại được.
          if (done) {
            const u = new URL(window.location.href);
            u.searchParams.delete('remindCart');
            history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
          }
        }
      })();
    }

    // order history — paginate 10/page + lineup + お届け先 + per-item add-to-cart
    const sortSel = root.querySelector('[data-order-sort]');
    const pager = root.querySelector('[data-order-pager]');
    let curSort = 0;
    const PER = 10;

    // `isChildOrder` = đơn của tài khoản con (cha FO/ASOSHI đang xem). Joomla ẩn nút
    // 同じ数量をカートに入れる bằng chính owner check — order_products_details.tpl.php:35
    // `... && $auth['user_id'] == $user_id`, với $user_id = user_id của ĐƠN (ps_order.php:1263).
    function lineupHtml(items, isChildOrder) {
      return (items || []).map((it) => {
        // Thiếu ảnh → noimage.gif (giống PDP/category card), KHÔNG để trống: ô rỗng
        // làm các card trong hàng lệch nhau.
        const photo = `<img src="${esc(it.image || NO_IMAGE)}" class="mx-auto h-auto w-[100px]" alt="${esc(it.name)}"${it.sku ? ` data-lineup-img data-sku="${esc(it.sku)}"` : ''}>`;
        const link = it.url ? `<a href="${esc(it.url)}" class="text-ink-blue no-underline">${esc(it.name)}</a>` : esc(it.name);
        const cartBtn = (!isChildOrder && it.buyable && !it.is_present && it.shopify_variant_id)
          ? `<a href="javascript:void(0);" data-add-item data-variant="${it.shopify_variant_id}" data-qty="${it.quantity}" class="mt-1 inline-block rounded border border-ink-orange px-2 py-1 text-xs text-ink-orange no-underline">同じ数量をカートに入れる</a>`
          : '';
        // Link 商品レビュー theo product cụ thể (product+pid) — tránh dead-end CTA hub.
        const reviewBtn = it.review_url
          ? `<a href="${esc(it.review_url)}" class="mt-1 block text-xs text-ink-blue underline">レビューを書く</a>`
          : '';
        return `<div class="order-history-product">
          ${photo}
          <p class="ik-lineup-name ik-anywhere mt-1 text-xs leading-tight">${link}</p>
          <p class="text-xs text-gray-600">購入数：${it.quantity}</p>
          ${cartBtn}
          ${reviewBtn}
        </div>`;
      }).join('');
    }

    // d = shape {items, total} của /orders (hoặc field `orders` trong /mypage/summary);
    // null = lỗi fetch → fallback text.
    function renderOrders(d, page, sort) {
      const box = root.querySelector('[data-order-history]'); if (!box) return;
      if (d === null) { box.innerHTML = '<p class="text-sm text-gray-600">ご注文履歴がありません。</p>'; if (pager) pager.innerHTML = ''; return; }
      {
        const items = (d && d.items) || [];
        if (!items.length) { box.innerHTML = '<div class="rounded border border-dashed border-ink-grayLine bg-gray-50 p-6 text-center text-sm text-gray-700">ご注文履歴がありません。</div>'; if (pager) pager.innerHTML = ''; return; }
        box.innerHTML = items.map((o) => {
          // 予約受付完了 chỉ khi đơn ở 'C' (Cnet_OrderStatus_Finish) VÀ là đơn 予約 —
          // ps_order.php:977,1202. Xét mỗi reserve_flg thì đơn đã huỷ vẫn hiện ảnh
          // 予約受付完了 dù `status_label` server trả về là キャンセル済み.
          const simg = (o.reserve_flg && o.status_code === 'C') ? SI.reserve : SI[o.status_code];
          const status = simg ? `<img class="order-history-status-image inline-block h-auto align-middle" src="${simg}" alt="${esc(String(o.status_label || '').replace(/<br>/g, ' '))}" width="280" height="97">` : `<span class="text-sm">${o.status_label || ''}</span>`;
          // Đơn tk con (cha FO/ASOSHI xem): お届け先 hiện 名字 chủ đơn thay cho địa chỉ
          // giao thật — ps_order.php:1207-1213 thay hẳn giá trị, không thêm nhãn nào.
          const deliveryLabel = o.is_child_order
            ? `${esc(o.owner_name || '')}`
            : esc(o.delivery_label || '会員情報と同じ');
          // 再注文 chỉ cho đơn của chính mình (ps_order.php:1220).
          // 自由選択 (`has_select_product`): nút này add variant CHA không kèm
          // `_mix_match_skus` → đơn mới mất 内訳 (server chặn thêm ở /orders/{id}/reorder).
          const reorderBtn = (o.is_child_order || o.has_select_product)
            ? ''
            : `<a href="javascript:void(0);" data-reorder="${o.order_id}" class="inline-flex min-h-10 items-center justify-center rounded bg-ink-orange px-4 font-bold text-white no-underline">同じ商品を再注文する</a>`;
          // Nút 承認 đứng SAU 注文詳細 và tô đỏ như ps_order.php:1246-1252.
          const approveBtn = o.can_approve
            ? `<a href="javascript:void(0);" data-approve="${o.order_id}" class="inline-flex min-h-10 items-center justify-center rounded border border-[#ff0000] bg-ink-approve px-4 font-bold text-white no-underline">注文を承認する</a>`
            : '';
          return `<article class="mb-4 rounded border border-ink-grayLine p-4">
            <div class="mb-3 flex flex-wrap items-center justify-between gap-2 border-b border-ink-grayLine pb-2">
              <span class="text-sm font-bold text-gray-700">ご注文日：${ymd(o.cdate)}</span>${status}
            </div>
            <div class="grid gap-4 lg:grid-cols-[220px_minmax(0,1fr)]">
              <div class="text-sm">
                <p>注文番号：${esc(o.order_number)}</p>
                <p>合計：<span class="text-lg font-bold text-ink-red">${fmt(o.order_total)}</span> 円</p>
                <p>お届け先：${deliveryLabel}</p>
                <div class="mt-3 flex flex-col gap-2">
                  ${reorderBtn}
                  <a class="inline-flex min-h-10 items-center justify-center rounded border border-ink-blue px-4 font-bold text-ink-blue no-underline" href="${orderUrl}?id=${o.order_id}">注文詳細</a>
                  ${approveBtn}
                </div>
              </div>
              <div class="order-history-products">${lineupHtml(o.items, o.is_child_order)}</div>
            </div>
          </article>`;
        }).join('');
        renderPager((d && d.total) || 0, page || 1, sort || 0);
        hydrateLineupImages(box);
      }
    }

    // Ảnh lineup theo getImageUrlForEmpty (ps_order.php:2083): keep_image giữ ảnh gốc;
    // 販売終了 → soldout ưu tiên hơn 欠品 → stockout. /stock lỗi → giữ ảnh gốc.
    async function hydrateLineupImages(box) {
      const imgs = [...box.querySelectorAll('[data-lineup-img][data-sku]')];
      const skus = [...new Set(imgs.map((img) => img.dataset.sku))];
      const stocks = {};
      for (let i = 0; i < skus.length; i += 50) {
        try {
          const j = await window.inkApi.get('/stock', { skus: skus.slice(i, i + 50).join(',') });
          Object.assign(stocks, (j && j.data && j.data.items) || {});
        } catch (e) { console.warn('lineup stock fail', e); break; }
      }
      imgs.forEach((img) => {
        const st = stocks[img.dataset.sku];
        if (!st || st.keep_image === true) return;
        if (st.buy_enable === false && SOLDOUT_IMG) img.src = SOLDOUT_IMG;
        else if (st.status === 'out_of_stock' && STOCKOUT_IMG) img.src = STOCKOUT_IMG;
      });
    }

    async function loadOrders(sort, page) {
      try {
        const j = await window.inkApi.get('/orders', { page: page || 1, per_page: PER, sort: sort || 0 });
        renderOrders((j && j.data) || null, page || 1, sort || 0);
      } catch (e) { console.warn('orders fail', e); renderOrders(null, page || 1, sort || 0); }
    }

    // Windowed pager — CHỈ render 1 / last / current±2 +「…」. Tránh render toàn bộ
    // trang (user 2147 đơn → 215 nút flex không wrap → tràn ngang 11k px → vỡ layout).
    function renderPager(total, page, sort) {
      if (!pager) return;
      const pages = Math.ceil(total / PER);
      if (pages <= 1) { pager.innerHTML = ''; return; }
      const link = (p, label, cls) => `<a href="javascript:void(0);" data-page="${p}" class="rounded border border-ink-grayLine px-${cls || 3} py-1 text-ink-black no-underline">${label}</a>`;
      const gap = '<span class="px-1 text-gray-400">…</span>';
      const nums = [...new Set([1, pages, page, page - 1, page + 1, page - 2, page + 2].filter((p) => p >= 1 && p <= pages))].sort((a, b) => a - b);
      let html = '';
      if (page > 1) html += link(page - 1, '‹ 前', 2);
      let prev = 0;
      for (const p of nums) {
        if (prev && p - prev > 1) html += gap;
        html += p === page
          ? `<span class="rounded border border-ink-green bg-ink-green px-3 py-1 text-white">${p}</span>`
          : link(p, p);
        prev = p;
      }
      if (page < pages) html += link(page + 1, '次 ›', 2);
      pager.innerHTML = html;
    }

    // 表示 button apply sort (page 1); pager click; per-item + reorder add-to-cart.
    // overlay 処理中 cho action gửi request (表示/pager/reorder).
    const withOverlay = (p) => { window.inkProcessing?.show(); return Promise.resolve(p).finally(() => window.inkProcessing?.hide()); };
    root.querySelector('[data-order-apply]')?.addEventListener('click', () => { curSort = parseInt(sortSel.value, 10) || 0; withOverlay(loadOrders(curSort, 1)); });
    if (pager) pager.addEventListener('click', (e) => { const a = e.target.closest('[data-page]'); if (a) withOverlay(loadOrders(curSort, parseInt(a.dataset.page, 10))); });
    root.querySelector('[data-order-history]')?.addEventListener('click', async (e) => {
      // 承認 (cha アソシエイツ duyệt đơn con) — thành công thì load lại ĐÚNG trang đang
      // xem để status đổi 承認待ち → 出荷準備中 và nút biến mất.
      const apA = e.target.closest('[data-approve]');
      if (apA) {
        const ok = await window.inkOrderApprove?.run(apA.dataset.approve, root.querySelector('[data-order-approve-msg]'));
        if (ok) await loadOrders(curSort, 1);
        return;
      }
      const reA = e.target.closest('[data-reorder]');
      if (reA) {
        const id = reA.dataset.reorder; reA.textContent = '処理中...';
        window.inkProcessing?.show();
        try {
          const j = await window.inkApi.post(`/orders/${id}/reorder`, { mode: 'replace' });
          if (!j || !j.data) { reA.textContent = '再注文できません'; window.inkProcessing?.hide(); return; }
          await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
          // Check res.ok: variant sold-out/invalid → 422, KHÔNG redirect cart (tránh cart trống sau clear) + báo lỗi.
          const addRes = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: j.data.lines.map((l) => ({ id: l.variant_id, quantity: l.quantity })) }) });
          if (!addRes.ok) { reA.textContent = 'カート追加に失敗'; window.inkProcessing?.hide(); return; }
          window.location.href = '/cart'; // overlay giữ tới khi chuyển trang
        } catch (err) { console.warn('reorder fail', err); reA.textContent = 'カート追加に失敗'; window.inkProcessing?.hide(); }
        return;
      }
      const addA = e.target.closest('[data-add-item]');
      if (addA) {
        const orig = addA.textContent; addA.textContent = '追加中…';
        try {
          // Check res.ok: sold-out/invalid → 422, KHÔNG báo "追加しました" giả.
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(addA.dataset.variant, 10), quantity: parseInt(addA.dataset.qty, 10) || 1 }] }) });
          if (!res.ok) throw new Error('cart add not ok');
          addA.textContent = '追加しました'; document.dispatchEvent(new CustomEvent('ink:cart:updated')); document.dispatchEvent(new CustomEvent('ink:cart:added'));
          setTimeout(() => { addA.textContent = orig; }, 1500);
        } catch (err) { console.warn('add item fail', err); addA.textContent = '失敗'; setTimeout(() => { addA.textContent = orig; }, 1500); }
      }
    });

    // coupon — card layout design (badge 利用可能 + tên | コード/期限 cột phải);
    // >2 → item 3+ nằm trong <details すべてのクーポンを表示> (すべて表示 ⇄ 簡略表示).
    // Anniversary/final coupon (fixed flag) → highlight cam paleYellow như card đầu design.
    function renderCoupons(items) {
      const box = root.querySelector('[data-coupon-list]'); if (!box) return;
      if (items === null) { box.innerHTML = '<p class="text-sm text-gray-600">使用可能なクーポンはありません。</p>'; return; }
      {
        if (!items.length) { box.innerHTML = '<div class="rounded border border-dashed border-ink-grayLine bg-gray-50 p-4 text-sm text-gray-700"><p class="font-bold">所有クーポンなし</p><p class="mt-1">現在利用できるクーポンはありません。</p></div>'; return; }
        const card = (c) => {
          const diff = Number(c.coupon_use_end_diff);
          const fixed = c.anniversary_coupon_flg === 1 || c.final_order_coupon_flg === 1;
          const dt = new Date(c.coupon_use_end * 1000);
          const end = `${dt.getFullYear()}/${pad(dt.getMonth() + 1)}/${pad(dt.getDate())} ${fixed ? '23:59' : pad(dt.getHours()) + ':' + pad(dt.getMinutes())}`;
          const expiry = (diff >= 0 && diff <= 10) ? `<span class="inline-block rounded bg-ink-red px-2 py-0.5 text-xs text-white">${diff === 0 ? '有効期限は今日まで！' : 'あと' + diff + '日!'}</span>` : '';
          const boxCls = fixed ? 'border-ink-orange bg-ink-paleYellow' : 'border-ink-grayLine bg-white';
          const badgeCls = fixed ? 'bg-ink-orange' : 'bg-ink-green';
          const nameCls = fixed ? ' text-ink-red' : '';
          return `<div class="rounded border ${boxCls} p-4">
            <div class="grid gap-4 lg:grid-cols-[minmax(0,1fr)_220px] lg:items-center">
              <div class="min-w-0">
                <div class="flex flex-wrap items-center gap-2">
                  <span class="rounded ${badgeCls} px-3 py-1 text-xs font-bold text-white">利用可能</span>
                  <p class="text-lg font-bold${nameCls}">${esc(c.coupon_name)}</p>
                  ${expiry}
                </div>
                <p class="mt-2 text-sm leading-6 text-gray-700">${fmt(c.coupon_discount)}円OFF・商品合計${fmt(c.coupon_use_subtotal)}円以上のお買い物で利用可能（有効回数：${c.coupon_use_max}回）。カート画面で利用できます。</p>
              </div>
              <dl class="grid gap-1 text-sm sm:grid-cols-[88px_1fr] lg:block">
                <dt class="font-bold text-gray-600 lg:text-xs">クーポンコード</dt>
                <dd class="font-bold lg:mt-1">${esc(c.coupon_code)}</dd>
                <dt class="mt-2 font-bold text-gray-600 lg:text-xs">有効期限</dt>
                <dd class="lg:mt-1">${end}まで</dd>
              </dl>
            </div>
          </div>`;
        };
        const head = items.slice(0, 2).map(card).join('');
        const extra = items.slice(2).map(card).join('');
        box.innerHTML = `<div class="grid gap-3">${head}</div>` + (extra
          ? `<details class="mt-4 rounded border border-ink-grayLine bg-white p-4" data-state="coupon-list-expanded">
              <summary class="cursor-pointer text-sm font-bold text-ink-blue" data-coupon-toggle>すべてのクーポンを表示</summary>
              <div class="mt-3 grid gap-3">${extra}</div>
            </details>`
          : '');
        const det = box.querySelector('details');
        det?.addEventListener('toggle', () => { det.querySelector('[data-coupon-toggle]').textContent = det.open ? '簡略表示' : 'すべてのクーポンを表示'; });
      }
    }

    // 配達先 list — 1 hàng/địa chỉ [tên | 〒住所+TEL | 変更/削除];
    // >3 → item 4+ trong <details すべての配達先を表示>. 削除 = confirm → DELETE → reload (giống trang address).
    // preloaded: array = render luôn (từ /mypage/summary) · null = lỗi summary →
    // fallback text · undefined = tự fetch (refresh sau 削除).
    async function loadAddresses(preloaded) {
      const wrap = root.querySelector('[data-address-list]'); if (!wrap) return;
      if (preloaded === null) { wrap.innerHTML = '<p class="text-sm text-gray-600">配達先未登録です。</p>'; return; }
      try {
        let items = preloaded;
        if (!Array.isArray(items)) {
          const j = await window.inkApi.get('/addresses', { sort: 'id' });
          items = (j && j.data) || [];
        }
        if (!items.length) { wrap.innerHTML = '<div class="rounded border border-dashed border-ink-grayLine bg-gray-50 p-4 text-sm text-gray-700"><p class="font-bold">配達先なし</p><p class="mt-1">まだ登録されていません。</p></div>'; return; }
        const card = (a) => `
          <div class="rounded border border-ink-grayLine bg-white p-4" data-receiver-id="${a.receiver_id}">
            <div class="grid gap-4 lg:grid-cols-[180px_minmax(0,1fr)_150px] lg:items-center">
              <div><p class="text-lg font-bold">${esc(a.label || a.name)}</p></div>
              <div class="text-sm leading-6 text-gray-700">
                <p>〒${esc(a.zip_1)}-${esc(a.zip_2)} ${esc(a.pref_name || '')}${esc(a.city || '')}${esc(a.town || '')} ${esc(a.building || '')}</p>
                <p>TEL: ${esc(a.phone || '')}</p>
              </div>
              <div class="flex gap-2 lg:justify-end">
                <a class="inline-flex min-h-10 items-center justify-center rounded border border-ink-blue px-4 text-sm font-bold text-ink-blue no-underline" href="${addressUrl}?edit=${a.receiver_id}">変更</a>
                <button type="button" data-addr-delete class="min-h-10 rounded border border-gray-400 px-4 text-sm font-bold text-gray-700">削除</button>
              </div>
            </div>
          </div>`;
        const head = items.slice(0, 3).map(card).join('');
        const extra = items.slice(3).map(card).join('');
        wrap.innerHTML = `<div class="grid gap-3">${head}</div>` + (extra
          ? `<details class="mt-4 rounded border border-ink-grayLine bg-white p-4" data-state="address-list-expanded">
              <summary class="cursor-pointer text-sm font-bold text-ink-blue" data-address-toggle>すべての配達先を表示</summary>
              <div class="mt-3 grid gap-3">${extra}</div>
            </details>`
          : '');
        const det = wrap.querySelector('details');
        det?.addEventListener('toggle', () => { det.querySelector('[data-address-toggle]').textContent = det.open ? '簡略表示' : 'すべての配達先を表示'; });
      } catch (e) { console.warn('addresses fail', e); wrap.innerHTML = '<p class="text-sm text-gray-600">配達先未登録です。</p>'; }
    }

    // 削除 địa chỉ từ hub (design #27 có nút 削除) — cùng behavior trang address (ADR-020).
    root.querySelector('[data-address-list]')?.addEventListener('click', async (e) => {
      if (!e.target.matches('[data-addr-delete]')) return;
      const cardEl = e.target.closest('[data-receiver-id]'); if (!cardEl) return;
      if (!window.confirm('この配達先を削除してよろしいですか？')) return;
      window.inkProcessing?.show();
      let j;
      try { j = await window.inkApi.delete(`/addresses/${cardEl.dataset.receiverId}`); } finally { window.inkProcessing?.hide(); }
      // 204 no-body = OK ({data:null}); lỗi transport mang `error`, lỗi nghiệp vụ
      // mang errors/message từ Laravel.
      if (j && j.error) {
        window.alert('削除に失敗しました。');
      } else if (j && (j.errors || j.message)) {
        const errs = j.errors ? Object.values(j.errors).flat() : [j.message];
        window.alert(errs.join('\n') || '削除に失敗しました。');
      }
      await loadAddresses();
    });

    // マイプリンター — full management (bê full design vào hub).
    // Dùng module chung InkPrinterManager (pulldown + memo + delete + card 対応商品 giàu:
    // badge 送料無料/在庫/当日出荷 + %お得 + stock AJAX). detailLink:true = card có nút
    // 「商品説明を見る」như design hub. Đăng ký MỚI vẫn ở /pages/printers (hub không add form).
    const printerSection = root.querySelector('[data-ink-printers]');
    if (printerSection && window.InkPrinterManager) {
      window.InkPrinterManager.initPanel(printerSection, { detailLink: true });
    }

    // MỘT call gộp thay 6 call lẻ (me/point/pending/orders/coupon/addresses —
    // perf §B3). Lỗi → từng khu render fallback text như hành vi cũ.
    (async () => {
      let d = null;
      try {
        const j = await window.inkApi.get('/mypage/summary');
        d = j && j.data;
      } catch (e) { console.warn('mypage summary fail', e); }

      const nameEl = root.querySelector('[data-mypage-name]');
      if (nameEl) nameEl.textContent = (d && d.me && (d.me.last_name || d.me.name)) || 'ゲスト';

      const bal = root.querySelector('[data-point-balance]');
      if (bal) bal.textContent = fmt(d && d.point ? d.point.balance : 0);
      if (d && d.point && d.point.expire_at) {
        const dt = new Date(d.point.expire_at * 1000);
        const ex = root.querySelector('[data-point-expiry]');
        if (ex) ex.textContent = `（${dt.getFullYear()}/${pad(dt.getMonth() + 1)}/${pad(dt.getDate())} まで有効）`;
      }

      const banner = root.querySelector('[data-pending-payment]');
      const pendingId = d && d.pending_payment && d.pending_payment.order_id;
      if (banner && pendingId) {
        banner.querySelector('[data-pending-link]').href = `${orderUrl}?id=${pendingId}`;
        banner.hidden = false;
      }

      renderOrders(d ? d.orders : null, 1, 0);
      renderCoupons(d ? (d.coupons || []) : null);
      loadAddresses(d ? (d.addresses || []) : null);
    })();
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else { document.addEventListener('ink:api:ready', startOnce, { once: true }); window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000)); }
})();
